/**
 * Returns whether an href should bypass client-side routing and render as an
 * external anchor.
 */
export function isExternalHref(href?: string): boolean {
  return Boolean(href && /^(?:(?:https?:)?\/\/|mailto:|tel:)/i.test(href))
}
